export default __webpack_public_path__ + "static/soehne-mono-web-buch-kursiv-e9a12237d88ae304f45c5c8012e08932.eot";